"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _react = _interopRequireWildcard(require("react"));
const TileContainer = (0, _styled.default)("div")`
    background-color: ${(0, _designTokensReact.color)("color--background--surfaces--body")};
    box-sizing: border-box;
    border-radius: 2px;
    padding: 16px;
    margin: 0;
    overflow: hidden;
    ${props => props.alwaysActive ? `box-shadow: ${(0, _designTokensReact.color)("elevation--default")};` : ""}
    &:hover {
        ${props => props.alwaysActive ? "" : `box-shadow: ${(0, _designTokensReact.color)("elevation--default")}`}
    }
`;
const Tile = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    clientId,
    alwaysActive,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(TileContainer, (0, _extends2.default)({
    alwaysActive: alwaysActive,
    "data-client-id": clientId,
    ref: ref
  }, rest), children);
});
exports.Tile = Tile;
Tile.displayName = "Tile";
//# sourceMappingURL=Tile.js.map